import type { Home, HomeSoftwareType } from 'features/home/types'

export enum softwareTilesValues {
  availableUpdates = 'availableUpdates',
  previous = 'previous',
  allUpdates = 'allUpdates',
  installedOnly = 'installedOnly',
}

/**
 * Available software is current or ahead-of the host, OR
 * Any upgrade/downgrade between SavantOS 10 and 11.
 */
export function softwareFilter(
  {
    softwareInfo: {
      version: { major: a },
    },
  }: Home,
  { version: { major: b } }: HomeSoftwareType
) {
  return b >= a || ((a === 10 || a === 11) && (b === 10 || b === 11))
}

export const requiresRuntimeLicense = new Set([
  0, // "Series 3 Host", "Pro Host"
  1, // "Linux Smart Host"
  2, // "Linux Smart Host 2"
  3, // "Smart Host with Control"
  7, // "Super Pro Host", "Super Pro Host v2"
  10, // "Linux Pro Host"
  11, // "Linux Super Pro Host"
  14, // "SHR-2000 Host"
  22, //  Mac mini (M2, 2023)
  23, //  Mac mini (M2 Pro, 2023)
  24, //  Mac Pro "M2 Ultra"
  25, //  Mac Studio (M2 Max, 2023)
  26, //  Mac Studio (M2 Ultra, 2023)
])

export const requiresSoftwareFilter = new Set([
  0, // "Series 3 Host", "Pro Host"
  3, // "Smart Host with Control"
  7, // "Super Pro Host", "Super Pro Host v2"
  14, // "SHR-2000 Host"
  22, //  Mac mini (M2, 2023)
  23, //  Mac mini (M2 Pro, 2023)
  24, //  Mac Pro "M2 Ultra"
  25, //  Mac Studio (M2 Max, 2023)
  26, //  Mac Studio (M2 Ultra, 2023)
])
